$(document).ready(function(){
    //詳細モーダルの制御
    const openModalBtn = document.querySelector('.CartFollowBtn__Btn');
    const closeModalBtn = document.querySelector('.CartFollowBtn__Btn--Close');
    const detailModal = document.querySelector('.CartFollowBtn__DetailBtnWrapper');
    const body = document.querySelector('body');

    if (!openModalBtn || !closeModalBtn || !detailModal) return;

    openModalBtn.addEventListener('click', function(){
        detailModal.classList.toggle('open-modal');
        body.classList.toggle('page-fixed');
    });
    closeModalBtn.addEventListener('click', function(){
        detailModal.classList.toggle('open-modal');
        body.classList.toggle('page-fixed');
    });


    //製品詳細用SlideToggle(JQuery)
    const accordionTrigger = $('.ProductPr__title');
    const accorionContent = $('.ProductPr__InfoWrapper');
    accordionTrigger.on('click', function(){
        accorionContent.slideToggle();
    });


    // 追従ボタン文言変更処理
    const buttonText = document.querySelector('.CartFollowBtn__Btn span');

    function updateButtonText() {
        if (detailModal.classList.contains('open-modal')) {
            buttonText.textContent = '商品ページに戻る';
        } else {
            buttonText.textContent = '購入する';
        }
    }

    updateButtonText(); // 初期ロードで実行

    // クラスの変更をリアルタイムで監視
    const observer = new MutationObserver(updateButtonText);
    observer.observe(detailModal, { attributes: true, attributeFilter: ['class'] });
})
